
import { Component, Vue } from "vue-property-decorator";
import { MetaInfo } from "vue-meta";
// import Navbar from "@/components/Utility/Navbar.vue";
// import Footer from "@/components/Utility/Footer.vue";
import ServiceRow from "@/components/Service/ServiceRow.vue";
import ServiceModal from "@/components/Service/ServiceModal.vue";
import ServiceSearchKeyword from "@/components/Service/ServiceSearchKeyword.vue";
import ServiceListSkeleton from "@/components/Service/ServiceListSkeleton.vue";
import tigermaster from "fdtigermaster-client-sdk";

type ServiceStatus = "loading" | "ready" | "empty" | "error";

declare type workingCategoryItem = {
  L3: string[];
  desc: string;
  imagePath: string;
  name: string;  
}

declare type workingCategory = {
  L2: workingCategoryItem[];
  desc: string;
  name: string;
}

@Component({
  components: {
    // Navbar,
    // Footer,
    ServiceRow,
    ServiceModal,
    ServiceSearchKeyword,
    ServiceListSkeleton,
  },
})


export default class Service extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: "服務項目｜師虎來了修繕服務總覽",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "師虎來了提供水電、抓漏、裝潢修繕、清潔、病媒防治等多項到府修繕服務，瀏覽完整服務分類與項目，快速找到符合需求的專業師傅。",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "服務項目｜師虎來了修繕服務總覽",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "師虎來了提供水電、抓漏、裝潢修繕、清潔、病媒防治等多項到府修繕服務，瀏覽完整服務分類與項目，快速找到符合需求的專業師傅。",
        },
      ],
      link: [
        {
          vmid: "canonical",
          rel: "canonical",
          href: "https://www.fdtigermaster.com/Service",
        },
      ],
    };
  }

  //data
  inputKeyword = "";
  workingCategoryList:workingCategory[] = [];
  compositionStatus = false; //鍵盤打字
  activeCategoryIndex!: number; //tab點到的項目的index
  chooseLevelOne = 0;
  chooseLevelThree = 0; //null
  workingCategoryData = {};
  serviceStatus: ServiceStatus = "loading";
  showServiceRow = true;
  showKeyword = false;
  searchResult: {
    active:number;
    commercialWarrantyDay:number;
    commonPrice:number;
    consumerWarrantyDay:number;
    createBy:string;
    createDate:string;
    description:string;
    id:string;
    maxPrice:number;
    minPrice:number;
    name: string;
    priceRangeDescription:string;
    skillItemId:string;
    warrantyDescription:string;    
  }[] = [];
  target!: HTMLElement;

  //hook
  created(): void {
    const routeCategoryIndex = Number(this.$route.query.value);

    if (Number.isInteger(routeCategoryIndex) && routeCategoryIndex >= 0) {
      this.activeCategoryIndex = routeCategoryIndex;
      this.chooseLevelOne = routeCategoryIndex;
    } else {
      this.activeCategoryIndex = 0;
      this.chooseLevelOne = 0;
    }

    this.getData();
  }

  //methods
  clearContent(e: any): void {
    e.target.placeholder = "";
    this.inputKeyword = "";
    this.showServiceRow = true;
  }
  getIndex(index:number): void {
    this.chooseLevelOne = index;
    
    this.activeCategoryIndex = index;

    this.inputKeyword = "";
    this.showServiceRow = true;
    this.showKeyword = false;
  }
  async getData(): Promise<void> {
    this.serviceStatus = "loading";

    try {
      const data = await tigermaster.services.Level.download();
      this.workingCategoryList = Array.isArray(data) ? data : [];

      if (this.workingCategoryList.length === 0) {
        this.serviceStatus = "empty";
        return;
      }

      if (this.chooseLevelOne >= this.workingCategoryList.length) {
        this.chooseLevelOne = 0;
        this.activeCategoryIndex = 0;
      }

      this.serviceStatus = "ready";
    } catch (error) {
      console.error("Failed to load service categories.", error);
      this.serviceStatus = "error";
    }
  }
  getWorkingCategoryData(data: { id: string }): void {
    this.workingCategoryData = data;
    this.$bvModal.show("service-info-modal");
  }
  async onSearchClick(): Promise<void> {
    if (this.compositionStatus) return;
    this.activeCategoryIndex = -1;

    //const database = new Database();
    const query = tigermaster.database.query("working_category");
    const searchArray = Object.entries(this.inputKeyword);

    searchArray.forEach((ele: any) => {
      ele[2] = "LIKE";
      ele[1] = "%" + ele[1] + "%";
      query.where("working_category.name", ele[2], ele[1]);
    });

    try {
      const res = await query.get();
      this.searchResult = res.data;
    } catch{
      alert("查無此項目");
    }
    this.showServiceRow = false;
    this.showKeyword = true;
  }

  //computed
  get levelOneList(): string[] {
    return this.workingCategoryList.map((item: { name: string }) => {
      return item.name;
    });
  }
  get L2(): workingCategoryItem[] {
    const selectedCategory = this.workingCategoryList[this.chooseLevelOne];
    return selectedCategory ? selectedCategory.L2 : [];
  }
}
